<template>
  <div id="app">
    <headertop></headertop>
    <div class="main">
      <div style="width: 60%; padding: 0 20%;">
        <video ref="videoPlayer" class="video-js video vjs-big-play-centered" controlslist="nodownload noremoteplayback" oncontextmenu = "return false">
        </video>
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
export default{
  name:'App',
  data(){
    return{
      player: null,
      videoOptions: {
        lang: 'zh-CN',
        autoplay: true,//自动播放
        controls: true,//用户可以与之交互的控件
        loop:true,//视频一结束就重新开始
        muted:false,//默认情况下将使所有音频静音
        // aspectRatio:"16:9",//显示比率
        // preload:true,//预加载
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        playbackRates: [0.5, 1, 1.5,2,3],//倍数
        errorDisplay: false,
        fluid: true,
        fullscreen:{
            options: {navigationUI: 'hide'}
        },
        sources:[{
          src: "https://edu.zhiyaozhishi.com/uploads/customized.mp4",
          type: ""
        }],
      },
    }
  },
  components:{
    headertop:Header,
    footerbom:Footer
  },
  mounted:function(){
    this.start_player()
  },
  methods:{
    start_player(){
      let _this=this
      if(_this.player){
        _this.player.src({type:_this.videoOptions.sources[0].type, src:_this.videoOptions.sources[0].src})
        _this.player.load()
      }else{
        _this.$nextTick(()=>{
          _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {
          })
        })
      }
    },
  }
}
</script>

<style scoped>
  .main{
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  h1 {
    margin: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/visitor/Courses/Customizedcourses.vue